import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';

import * as AccountingReportActions from './accounting-report.actions';
import { type AccountingReportState } from './interfaces';

const initialState: AccountingReportState = {
  accountingReports: [],
};

const featureAccountingReportSelector =
  createFeatureSelector<AccountingReportState>('accountingReport');

export const accountingReportsSelector = createSelector(
  featureAccountingReportSelector,
  state => state.accountingReports,
);

export const accountingReportReducer = createReducer(
  initialState,
  on(
    AccountingReportActions.getAccountingReportsSuccess,
    (state, { accountingReports }) => ({
      ...state,
      accountingReports,
    }),
  ),
);
